import createAsyncActions from 'store/_utils/createAsyncActions';
import { TLoginState } from './loginModel';

enum ELoginActions {
  LOGIN = 'login/LOGIN'
}

export const loginSet = createAsyncActions<TLoginState>(ELoginActions.LOGIN);
